// extracted by css-extract-rspack-plugin
var _1 = "g3";
var _2 = "j";
var _3 = "g2";
var _4 = "g7";
var _5 = "g6";
var _6 = "g0";
var _7 = "gv";
var _8 = "g";
var _9 = "f2";
var _a = "b";
var _b = "g4";
var _c = "g5";
var _d = "g9";
var _e = "cl";
var _f = "g1";
var _10 = "e6";
var _11 = "g8";
var _12 = "f";
export { _1 as "author", _2 as "buttonV2Component", _3 as "comment", _4 as "commentReplies", _5 as "commentText", _6 as "discountReviewComponent", _7 as "discountReviewModal", _8 as "inner", _9 as "linkComponent", _a as "modalComponent", _b as "moment", _c as "momentDate", _d as "noComments", _e as "panelComponent", _f as "reviewButton", _10 as "titleText", _11 as "viewMore", _12 as "wrapper" }
